<div class="error-message">
<ng-container *ngIf="isNotLoggedIn; else loggedinHeader">
  <mapfre-header></mapfre-header>
</ng-container>
<ng-template #loggedinHeader>
  <app-loggedin-account-header></app-loggedin-account-header>
</ng-template>
<div class="service-err-msg container mapfre-content">
    <mapfre-card [singleCard]="false">
        <div class="row text-center s-msg-header">
          <div class="header-col">
            <div class="header-icon full-icon">                
                  <ng-container *ngIf="state?.errInfo?.hideContactSection; else defaultErrorIcon">
                    <img src="./assets/img/images/icon-warning.svg" width="64px" height="64px" alt="warning icon" />
                  </ng-container>
                  <ng-template #defaultErrorIcon>
                    <img src="./assets/img/images/service-error-logo.svg" width="64px" height="64px" alt="compensation icon" />
                  </ng-template>
              </div>
              <h1 class="title-copy font-weight-normal">
                <ng-container *ngIf="state?.errInfo?.hideContactSection; else defaultTitle">This page couldn't load</ng-container>
                <ng-template #defaultTitle>{{ state?.errInfo?.Title }}</ng-template>
              </h1>
              <div class="grey-color">
                <ng-container *ngIf="state?.errInfo?.hideContactSection; else defaultMessage">
                  We're unable to load this page due to a technical issue.<br/>
                  Please try again or contact us at <a href="tel:1-206-877-8313" class="underlineBQ">1-206-877-8313</a> if the problem continues.
                </ng-container>
                <ng-template #defaultMessage>
                  {{state?.errInfo?.Message}}<span *ngIf="!isAcmic && !state?.errInfo?.hideContactSection">Please contact us for assistance.</span>
                </ng-template>
              </div>
              <div class="margin-top mt-16" *ngIf="!state?.errInfo?.hideContactSection">
                <ng-container *ngIf="isAcmic; else maContactUs">                  
                  <div class="fs-16">To speak with our AAA Insurance team, call 
                    <a href="tel:1-844-295-4500" class="underlineBQ font-weight-500 text-nowrap">
                    {{ "1-844-295-4500" }}
                    </a>
                  </div>
                  <div class="fs-16">or email us at <a href="mailto:eccservicecenter@insure.wa.aaa.com" class="underlineBQ font-weight-500 text-nowrap">eccservicecenter&#64;insure.wa.aaa.com</a></div>
                </ng-container>
                <ng-template #maContactUs>
                  <a href="https://www.mapfreinsurance.com/contact/" target="_blank" rel="noopener">
                    <mapfre-button additionalClasses="basic primary large-btn">
                      {{ 'Contact us' | translate}}
                    </mapfre-button>
                  </a>
                </ng-template>                
              </div>
          </div>
        </div>

        <div class="container quick-access-services loggedout">
            <div class="loginInnrContainer">
              <div class="useful-link-title">
                <h2 class="title mb-3">{{'Some useful links' | translate }}</h2>
                <div class="bdr-btm"></div>
              </div>
              <section class="services">
                <ng-container *ngIf="state?.errInfo?.policyNumber?.length; else accountLevel">
                  <a [routerLink]="['/billing', state?.errInfo?.policyNumber , 'new-payment']" class="card-icon-lists">
                    <figure>
                      <img
                        src="assets/img/images/Make_Payment_Icon.svg"
                        alt="Make a Payment"
                        class="icon-w-h"
                      />
                    </figure>
                    <span [ngClass]="{'dm-sans-medium': !isAcmic}">
                      {{'MAKE_A_PAYMENT_TEXT' | translate}} <i class="material-icons">keyboard_arrow_right</i>
                    </span>
                  </a>
                </ng-container>
                <ng-template #accountLevel>
                    <ng-container *ngIf="isAcmic; else maPaymentLink">
                      <a [routerLink]="['/make-payment']" class="card-icon-lists">
                        <figure>
                          <img
                            src="assets/img/images/Make_Payment_Icon.svg"
                            alt="Make a Payment"
                            class="icon-w-h"
                          />
                        </figure>
                        <span>
                          {{'MAKE_A_PAYMENT_TEXT' | translate}} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>
                    </ng-container>           
                    <ng-template #maPaymentLink>
                      <a href="https://payments.mapfreinsurance.com/" class="card-icon-lists" target="_blank" rel="noopener">
                        <figure>
                          <img
                            src="assets/img/images/Make_Payment_Icon.svg"
                            alt="Make a Payment"
                            class="icon-w-h"
                          />
                        </figure>
                        <span class="dm-sans-medium">
                          {{'MAKE_A_PAYMENT_TEXT' | translate}} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>
                    </ng-template>
                    
                </ng-template>
                  <ng-container *ngIf="isNotLoggedIn; else loggedinLinks">
                    <ng-container *ngIf="isAcmic; else maReportClaim">
                      <a href="https://mcr.insure.wa.aaa.com/claims/#/ReportClaim" target="_blank" class="card-icon-lists" rel="noopener">
                        <figure>
                          <!-- src="assets/img/images/menuicon-claims.svg" -->
                          <img
                            src="assets/img/images/icon-car-repair-24h.svg"
                            alt="Report a Claim"
                            class="icon-w-h"
                          />
                        </figure>
                        <span>
                          {{'REPORT_A_CLAIM_TEXT' | translate }} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>
                    </ng-container>
                    <ng-template #maReportClaim>
                      <a href="https://mcr.mapfreinsurance.com/claims/#/ReportClaim" target="_blank" class="card-icon-lists" rel="noopener">
                        <figure>
                          <img
                            src="assets/img/images/icon-car-repair-24h.svg"
                            alt="Report a Claim"
                            class="icon-w-h"
                          />
                        </figure>
                        <span class="dm-sans-medium">
                          {{'REPORT_A_CLAIM_TEXT' | translate }} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>
                    </ng-template>
                  </ng-container>                             
                  <ng-template #loggedinLinks>
                    <a [routerLink]="['/my-insurance']" class="card-icon-lists">
                        <figure>
                          <!-- src="assets/img/images/icon-insurance-solid.svg" -->
                          <img
                            src="assets/img/images/icon-insurance.svg"
                            alt="My Insurance"
                            class="icon-w-h"
                          />
                        </figure>
                        <span [ngClass]="{'dm-sans-medium': !isAcmic}">
                          {{'Policies' | translate }} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>   
                    <a [routerLink]="['/claims']" class="card-icon-lists">
                        <figure>
                          <img
                            src="assets/img/images/icon-car-repair-24h.svg"
                            alt="Claims"
                            class="icon-w-h"
                          />
                        </figure>
                        <span [ngClass]="{'dm-sans-medium': !isAcmic}">
                          {{'Claims' | translate }} <i class="material-icons">keyboard_arrow_right</i>
                        </span>
                      </a>      
                  </ng-template>                          
              </section>
            </div>
          </div>        
      </mapfre-card>
</div>
</div>